import React from 'react';
import PropTypes from 'prop-types';
import ReactECharts from 'echarts-for-react';
import SkeletonPieChart from 'components/Loading/skeletonDoughnutChart';
import { formatNumber } from 'utils/functions';
import { InvestmentTypeColors } from '../constants';

function InvestmentChart({ operations, literals }) {
  if (!operations) {
    return <SkeletonPieChart size={230} />;
  }

  const data = operations.items
    .reduce((acc, { type = 'other', value = 0 }) => {
      const name = literals[type];
      const item = acc.find(i => i.name === name);
      if (item) {
        item.value += value;
      } else {
        acc.push({ name, value });
      }
      return acc;
    }, [])
    .sort((a, b) => b.value - a.value)
    .slice(0, 4);

  const option = {
    series: [{
      type: 'pie',
      radius: ['40%', '60%'],
      center: ['30%', '50%'],
      data,
      label: { show: false },
      color: data.map(item => {
        const type = operations.items.find(op => literals[op.type] === item.name)?.type;
        return InvestmentTypeColors[type] || InvestmentTypeColors.other;
      }),
    }],
    tooltip: {
      trigger: 'item',
      formatter: p => `${p.name}: ${formatNumber(p.value)}`,
    },
    legend: {
      orient: 'vertical',
      left: '60%',
      top: 'middle',
      textStyle: {
        fontSize: 12,
        color: '#333333',
        fontWeight: 'bold',
        lineHeight: 20,
        width: 200,
        overflow: 'truncate',
        rich: { value: { fontSize: 10, fontWeight: 'normal', color: '#666666' } },
      },
      icon: 'circle',
      itemGap: 12,
      formatter: name => {
        const total = data.reduce((sum, d) => sum + d.value, 0);
        const { value } = data.find(d => d.name === name);
        const pct = value ? ((value / total) * 100).toFixed(2) : 0;
        return `${name}\n{value|${pct}%}`;
      },
    },
  };

  return <ReactECharts option={option} />;
}

InvestmentChart.propTypes = {
  operations: PropTypes.object.isRequired,
  literals: PropTypes.object.isRequired,
};

export default InvestmentChart;
